<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     btn_review
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReveal"
        >
        </front-table>

        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel">
        </edit-dialog>

        <el-dialog append-to-body title="接口凭证" :visible.sync="reveal_visible" width="560px"
                   @closed="reveal_token = ''; reveal_secret = ''">
            <p style="margin-bottom: 4px; color: #606266; font-size: 13px;">Token(身份标识)</p>
            <p style="word-break: break-all; font-family: monospace; font-size: 15px; margin-top: 0;">
                {{ reveal_token }}
                <el-button type="text" size="mini" style="margin-left: 8px;" @click="copyOne(reveal_token)">复制</el-button>
            </p>

            <p style="margin-bottom: 4px; color: #606266; font-size: 13px;">Secret(签名密钥)</p>
            <p v-if="reveal_secret" style="word-break: break-all; font-family: monospace; font-size: 15px; margin-top: 0;">
                {{ reveal_secret }}
                <el-button type="text" size="mini" style="margin-left: 8px;" @click="copyOne(reveal_secret)">复制</el-button>
            </p>
            <p v-else style="color: #E6A23C; font-size: 13px; margin-top: 0;">
                该凭证未配置签名密钥,请重新生成一个凭证
            </p>

            <p style="color: #909399; font-size: 12px;">
                Token 用于标识身份,Secret 用于计算请求签名。<strong>Secret 只在此处可见,请通过安全渠道交给对接方,切勿写进日志或截图外发。</strong>
            </p>

            <div style="margin-top: 14px; padding-top: 12px; border-top: 1px solid #ebeef5;">
                <p style="margin: 0 0 4px; color: #606266; font-size: 13px;">接口调用说明(可直接发给对接方)</p>
                <p style="margin: 0; font-size: 13px; word-break: break-all;">
                    <i class="el-icon-document" style="color: #409EFF;"></i>
                    <a :href="doc_url" target="_blank" rel="noopener"
                       style="color: #409EFF; text-decoration: none; margin-left: 4px;">{{ doc_url }}</a>
                    <el-button type="text" size="mini" style="margin-left: 8px;" @click="copyOne(doc_url)">复制链接</el-button>
                </p>
                <p style="margin: 4px 0 0; color: #909399; font-size: 12px;">
                    内含签名算法、请求参数说明与 PHP / Python / curl 三种示例代码。
                </p>
            </div>

            <span slot="footer">
                <el-button size="small" @click="reveal_visible = false">关闭</el-button>
            </span>
        </el-dialog>
        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";

    export default {
        mixins: [FrontMixins],
        name: 'admin-client-token',
        components: {FrontTable, EditDialog},
        data() {
            return {
                reveal_visible: false,
                reveal_token: '',
                reveal_secret: ''
            }
        },
        created() {
            this.model = 'Admin.' + this.$route.meta.model;
        },
        computed: {
            // 用带域名的完整地址,复制出来可以直接发给对接方
            doc_url() {
                return window.location.origin + '/open-api-doc';
            }
        },
        methods: {
            handleReveal(id) {
                this.$api(this.model + '.Reveal', {id: id}, true).then(res => {
                    this.reveal_token = res.data.data.token;
                    this.reveal_secret = res.data.data.secret || '';
                    this.reveal_visible = true;
                });
            },
            copyOne(text) {
                this.$copyText(text).then(() => {
                    this.$notice.success('已经复制到剪贴板');
                }).catch(() => {
                    this.$notice.error('复制失败,请手动复制');
                });
            }
        }
    }
</script>

<style lang="scss">
</style>
